import {CONFIG} from "../../config";
import {facet_replacement} from "./facet_replacements";

const getFacetLabel = (label, group = false) => {
    const labels = CONFIG.facetLabelReplacements;

    if (labels[group] && typeof labels[group] === 'function') {
        // note that even if the labels will results the same, they will NOT be grouped, so can end up with having
        // more facets with the exact same number.
        return labels[group](label);
    }

    return facet_replacement(label, CONFIG.facet_replacements, group);
};

export default getFacetLabel;